import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOpenQuote2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconOpenQuote2"><Path d="M22 20.0002V10.2145H18.5V3.6543C17.8911 3.8908 17.3105 4.08969 16.7475 4.4177C16.3321 4.65967 15.7803 5.03472 15.2275 5.57147C14.1128 6.65385 13 8.3922 13 10.9645V20.0002H22Z" fill="currentColor"/><Path d="M11 20.0002V10.2145H7.5V3.6543C6.89108 3.8908 6.31047 4.08969 5.74746 4.4177C5.33213 4.65967 4.78033 5.03472 4.22754 5.57147C3.11281 6.65385 2 8.3922 2 10.9645V20.0002H11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconOpenQuote2;
